exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#show-adressen[data-v-020cb357]{max-width:800px;margin:0 auto}.single-adressen[data-v-020cb357]{float:left;width:30%;min-height:150px;padding:20px;margin-top:20px;margin-bottom:20px;margin-right:2%;box-sizing:border-box;background:#eee}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-020cb357","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/adressen/showAdressen.vue
// module id = 202
// module chunks = 0